var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C7284",
    fillRule: "evenodd",
    d: "M20,8.00000004 C20,8.60689644 19.5263158,9.10344792 18.9473696,9.10344792 L3.57894766,9.10344792 L8.34210616,14.1241383 C8.76315896,14.5655165 8.76315896,15.2551722 8.34210616,15.6965515 C8.15789544,15.8896545 7.89473725,16 7.60526339,16 C7.34210574,16 7.05263188,15.8896545 6.8684217,15.6689649 L0.315789505,8.77241341 C-0.105263168,8.3310341 -0.105263168,7.64137899 0.315789505,7.22758565 L6.8684217,0.331034493 C7.28947439,-0.110344831 7.94736915,-0.110344831 8.3684213,0.331034493 C8.78947409,0.772413767 8.78947409,1.46206879 8.3684213,1.90344814 L3.57894766,6.89655171 L18.9473696,6.89655171 C19.5263158,6.89655171 20,7.39310319 20,8.00000004 Z",
    transform: "rotate(180 10 8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon_arrow.39a26a51.svg";
export { ForwardRef as ReactComponent };